module.exports = __webpack_public_path__ + "assets/img/module_card_menu_mobile.svg";